console.log("Decision Engine Loaded");

function generateDecisionExplanation(answers){

    let reply = "";

    reply += "🤖 <b>AI Recommendation</b><br><br>";

    if(answers.location){

        reply += "📍 Location : <b>" +
        answers.location +
        "</b><br>";

    }

    if(answers.wifi){

        reply += "📶 Wi-Fi : <b>" +
        answers.wifi +
        "</b><br>";

    }

    if(answers.budget){

        reply += "💰 Budget : <b>" +
        answers.budget +
        "</b><br>";

    }

    reply += "<br>";

    //----------------------------------------

    if(answers.location === "Garden"){

        reply +=
        "I recommend outdoor CCTV cameras because they are weather-resistant and provide wide-area surveillance.";

    }

    else if(answers.location === "Home"){

        reply +=
        "Indoor and Bulb Cameras are suitable because they are easy to install and provide complete indoor coverage.";

    }

    else if(answers.location === "Shop"){

        reply +=
        "PTZ and Dual Lens cameras provide wider coverage for shops and help monitor customer movement.";

    }

    else if(answers.location === "Warehouse"){

        reply +=
        "4G and PTZ cameras are recommended because warehouses require long-distance monitoring.";

    }

    return reply;

}